/**
 * Where DSS switches a vault upload from a single PUT to a multipart one. Shared
 * so the create flow, the replace guard and the bulk-upload cap can't drift apart.
 *
 * A copy of SSB configuration, so it can go stale with no release here — which is
 * why `uploadFailureMessage` maps the storage rejection rather than trusting this
 * to be current.
 */

/** At and above this size DSS mints a multipart plan instead of an upload target. */
export const MULTIPART_THRESHOLD_BYTES = 100 * 1024 * 1024;

/** Human label for the threshold, for use in copy. */
export const MULTIPART_THRESHOLD_LABEL = "100 MB";
